import { Combobox, Option } from '@fluentui/react-components';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FolderPermissionLevel } from '../../../../../../../api/types.gen';
import { useSetFormStateFromPermissionLevel } from '../../../hooks/useSetFormStateFrompermissionLevel';
import { useSetPermissionLevelOnFormStateChange } from '../../../hooks/useSetPermissionLevelOnFormStateChange';
import { IPermissionsDialogForm } from '../../../PermissionsDialogForm';
import { PermissionsField } from '../PermissionsField';

interface IPermissionLevelSelectOption {
  text: string;
  value: FolderPermissionLevel;
  isDisabled: boolean;
}

export function PermissionsLevelSelect() {
  const { t } = useTranslation();
  const { control } = useFormContext<IPermissionsDialogForm>();
  useSetPermissionLevelOnFormStateChange();
  const { updateFormStateBasedOnPermissionLevel } = useSetFormStateFromPermissionLevel();

  const options: IPermissionLevelSelectOption[] = [
    {
      text: t('permissions.modifyAction.levelGroup.options.owner'),
      value: FolderPermissionLevel.OWNER,
      isDisabled: false,
    },
    {
      text: t('permissions.modifyAction.levelGroup.options.publishingEditor'),
      value: FolderPermissionLevel.PUBLISHING_EDITOR,
      isDisabled: false,
    },
    {
      text: t('permissions.modifyAction.levelGroup.options.editor'),
      value: FolderPermissionLevel.EDITOR,
      isDisabled: false,
    },
    {
      text: t('permissions.modifyAction.levelGroup.options.publishingAuthor'),
      value: FolderPermissionLevel.PUBLISHING_AUTHOR,
      isDisabled: false,
    },
    {
      text: t('permissions.modifyAction.levelGroup.options.author'),
      value: FolderPermissionLevel.AUTHOR,
      isDisabled: false,
    },
    {
      text: t('permissions.modifyAction.levelGroup.options.noneditingAuthor'),
      value: FolderPermissionLevel.NONEDITING_AUTHOR,
      isDisabled: false,
    },
    {
      text: t('permissions.modifyAction.levelGroup.options.reviewer'),
      value: FolderPermissionLevel.REVIEWER,
      isDisabled: false,
    },
    {
      text: t('permissions.modifyAction.levelGroup.options.contributor'),
      value: FolderPermissionLevel.CONTRIBUTOR,
      isDisabled: false,
    },
    {
      text: t('permissions.modifyAction.levelGroup.options.none'),
      value: FolderPermissionLevel.NONE,
      isDisabled: false,
    },
    {
      text: t('permissions.modifyAction.levelGroup.options.custom'),
      value: FolderPermissionLevel.CUSTOM,
      isDisabled: true,
    },
  ];

  return (
    <PermissionsField label={t('permissions.modifyAction.levelGroup.label')}>
      <Controller
        control={control}
        name="permissionLevel"
        render={({ field: { value, onChange } }) => (
          <Combobox
            value={options.find((option) => option.value === value)?.text ?? ''}
            selectedOptions={value ? [value] : []}
            onOptionSelect={(_, data) => {
              onChange(data.optionValue);
              updateFormStateBasedOnPermissionLevel(data.optionValue as FolderPermissionLevel);
            }}
          >
            {options.map((option, index) => (
              <Option key={index} value={option.value} disabled={option.isDisabled}>
                {option.text}
              </Option>
            ))}
          </Combobox>
        )}
      />
    </PermissionsField>
  );
}
